import { PageController } from '@client/components/_core/layout/PageController';
import { useTrpc } from '@client/hooks/api/useTrpc';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';
import { QuestionnaireEditorPage } from './questionnaire-editor/QuestionnaireEditorPage';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId',
)({
    params: {
        parse({ questionnaireId }) {
            return { questionnaireId: BigInt(questionnaireId) };
        },
    },
    staticData: {
        presentation: 'fullPage',
        metadata: {
            title: 'Edit questionnaire',
        },
        breadcrumb: {
            title: 'Edit questionnaire',
        },
        ui: {
            icon: ClipboardList,
        },
        modules: ['claim'],
        permissions: ['settings:update'],
    },
    beforeLoad({ context, params }): ShareableRouteContext {
        void context.trpcUtils.questionnaire.getQuestionnaire
            .ensureData({
                id: params.questionnaireId,
            })
            .catch(() => undefined);

        return {
            breadcrumb: { title: 'Edit questionnaire' },
            ui: {
                title: <QuestionnaireHeaderTitle questionnaireId={params.questionnaireId} />,
                subtitle: 'Edit the claim lodgement questionnaire',
            },
        };
    },
    component: EditQuestionnaireRoute,
});

function QuestionnaireHeaderTitle({ questionnaireId }: { questionnaireId: bigint }) {
    const { trpc } = useTrpc();
    const { data } = trpc.questionnaire.getQuestionnaire.useQuery({ id: questionnaireId });
    const name = data?.name || 'Edit questionnaire';

    return (
        <span className="inline-block max-w-md truncate align-bottom" title={name}>
            {name}
        </span>
    );
}

function EditQuestionnaireRoute() {
    const { questionnaireId } = Route.useParams();
    return (
        <PageController route={Route}>
            <QuestionnaireEditorPage mode={['edit', questionnaireId]} />
        </PageController>
    );
}
